import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

export type NoticeType = 'green' | 'blue' | 'red' | 'yellow';

@Component({
    selector: 'app-notice',
    templateUrl: './notice.component.html',
    styleUrl: './notice.component.scss',
    standalone: false
})
export class NoticeComponent implements OnChanges {

  @Input() type: NoticeType = 'blue';
  @Input() title = '';
  @Input() message = '';
  @Input() wysiwygContent: string | null = null;
  @Input() icon = '';
  @Input() dismissible = false;
  @Input() dismissLabel = '';
  @Input() confirmLabel = '';
  @Input() confirmDisabled = false;
  @Input() dataTestId = 'notice';

  @Output() onDismissed = new EventEmitter<void>();
  @Output() onConfirmed = new EventEmitter<void>();

  parsedWysiwygContent: object | null = null;

  get noticeClass(): string {
    return `notice-${this.type}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['wysiwygContent']) {
      this.parseWysiwygContent();
    }
  }

  private parseWysiwygContent(): void {
    this.parsedWysiwygContent = null;

    if (!this.wysiwygContent) {
      return;
    }

    try {
      const content = JSON.parse(this.wysiwygContent);

      if (!content || !Array.isArray(content.ops)) {
        console.error('Invalid notice content: expected a Quill JSON.');
        return;
      }

      this.parsedWysiwygContent = content;
    } catch (error) {
      console.error('Error parsing notice content:', error);
    }
  }

  get showDismissButton(): boolean {
    return this.dismissible && !!this.dismissLabel;
  }

  get showConfirmButton(): boolean {
    return !!this.confirmLabel;
  }

  get hasActions(): boolean {
    return this.showDismissButton || this.showConfirmButton;
  }

  onDismiss(): void {
    this.onDismissed.emit();
  }

  onConfirm(): void {
    this.onConfirmed.emit();
  }
}
